<template>
  <i class="icon-small">
    <svg
      id="svg"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="18"
      height="18"
      viewBox="0, 0, 400,400"
    >
      <g id="svgg">
        <path
          id="path0"
          d="M190.820 24.773 C 182.377 26.403,176.861 28.633,169.889 33.235 C 166.480 35.485,95.313 105.622,95.313 106.731 C 95.313 106.896,98.893 107.031,103.269 107.031 C 114.544 107.031,120.806 108.313,128.516 112.198 C 135.797 115.867,136.097 116.139,166.992 146.909 C 198.866 178.654,197.574 177.528,202.148 177.528 C 206.724 177.528,205.463 178.625,236.914 147.286 C 261.986 122.303,266.308 118.159,269.499 116.051 C 278.896 109.839,286.315 107.536,298.184 107.146 L 305.157 106.917 270.450 72.189 C 230.811 32.528,230.075 31.879,220.285 27.961 C 211.942 24.622,198.909 23.211,190.820 24.773 M57.862 143.945 C 34.877 167.006,33.145 168.954,29.862 175.432 C 21.798 191.346,22.373 212.182,31.286 227.013 C 34.799 232.859,37.189 235.470,58.720 256.980 L 79.979 278.218 93.993 278.152 C 109.711 278.077,112.245 277.847,117.681 276.004 C 125.649 273.302,124.685 274.138,157.617 241.365 C 187.273 211.853,187.308 211.820,190.625 210.200 C 198.313 206.448,206.616 206.521,214.180 210.408 C 216.771 211.740,219.264 214.115,245.898 240.634 C 284.697 279.264,281.541 277.287,305.078 277.716 C 312.490 277.851,318.821 278.089,319.145 278.245 C 320.182 278.742,363.686 234.765,366.762 230.111 C 379.052 211.518,379.052 188.482,366.762 169.889 C 363.686 165.235,320.182 121.258,319.145 121.755 C 318.821 121.911,312.490 122.149,305.078 122.284 C 281.532 122.713,284.731 120.705,245.703 159.556 C 214.379 190.738,215.325 189.901,209.375 191.712 C 202.532 193.796,194.982 192.789,188.877 188.978 C 187.738 188.267,174.530 175.436,157.422 158.421 C 118.551 119.762,122.420 121.985,93.641 121.778 L 80.055 121.680 57.862 143.945 M198.633 222.911 C 196.811 223.463,194.702 225.473,167.188 252.885 C 136.084 283.873,135.797 284.133,128.516 287.802 C 120.840 291.670,114.495 292.966,103.223 292.968 C 98.872 292.968,95.313 293.104,95.313 293.269 C 95.313 294.378,166.480 364.515,169.889 366.765 C 189.506 379.715,214.557 378.874,233.008 364.646 C 234.512 363.487,251.361 346.911,270.450 327.811 L 305.157 293.083 298.184 292.854 C 286.313 292.464,278.891 290.160,269.499 283.948 C 266.308 281.838,261.965 277.674,236.719 252.511 C 203.134 219.037,205.459 220.845,198.633 222.911 "
          :stroke="color"
          stroke-width="20"
          fill="none"
          fill-rule="evenodd"
        ></path>
        <path
          id="path1"
          d=""
          stroke="none"
          fill="#08bcac"
          fill-rule="evenodd"
        ></path>
      </g>
    </svg>
  </i>
</template>

<script>
export default {
  name: 'PixLogo',

  props: {
    color: {
      type: String,
      required: false,
      default: 'gray',
    },
  },
};
</script>

<style>
</style>
